import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateChatHiddenLayoutRoute() {
  return <ModalStack />;
}
